import SidebarShared from "@swivu/shared-ui/src/components/SidebarShared.js";
import { Suspense, useRef } from "react";
import SidebarContent from "../components/SidebarContent.js";
import { ErrorBoundary, useScrollRestore } from "@swivu/shared-ui";
import Header from "../components/Header.js";
import { Outlet } from "react-router-dom";
import HorizontalWrapper from "../components/HorizontalWrapper.js";

const ValidatedLayout = () => {
  const divRef = useRef<HTMLDivElement | null>(null);
  useScrollRestore({ divRef: divRef });
  return (
    <ErrorBoundary>
      <div className="contents">
        <div className={`hidden md:block overflow-y-clip flex-none`}>
          <ErrorBoundary>
            <aside className={`w-56 h-full`}>
              <SidebarShared
                bodyClassName={`pt-0`}
                header={
                  <header
                    className={`dark:border-mono-700/50 flex  flex-none items-center justify-between gap-3 h-16  py-4 pl-4`}
                  >
                    <div className={`flex items-center gap-4`}>
                      <img
                        className="h-8 w-auto hidden"
                        src="/assets/swivu-logo.svg"
                        alt="Swivu Logo"
                      />
                      <h3 className={`text-xl font-bold`}>Swivu</h3>
                    </div>
                  </header>
                }
                body={
                  <Suspense fallback={<SidebarContent.Loading />}>
                    <ErrorBoundary>
                      <SidebarContent />
                    </ErrorBoundary>
                  </Suspense>
                }
              />
            </aside>
          </ErrorBoundary>
        </div>
        <div className={`grow flex flex-col overflow-hidden`}>
          <Header />
          <div
            ref={divRef}
            className={`grow overflow-y-auto overflow-x-hidden   `}
            id="main-content"
          >
            <HorizontalWrapper>
              {/* <div className="h-4" /> */}
              <ErrorBoundary>
                <Outlet />
              </ErrorBoundary>
            </HorizontalWrapper>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default ValidatedLayout;
